const probec311 = () => {
    return (
        <p>
            <br /><b>Радиус:</b> 20 мм<br /><b>Частота:</b> 2.0-7.0 МГц<br /><b>Количество элементов:</b> 128 элементов<br />
            <b>Клиническое применение:</b> Микроконвексный датчик для обследований взрослых
            <br /><br />            
        </p>
    );
}

export default probec311;